export enum ItemType {
  dir =2,
  file = 1
}

export class FileItem {
  id?: number;
  name: string;
  type: string;
  path?: string;
  children?: FileItem[];
  isOpen?: boolean;
  isSelected?: boolean;
  parent?: FileItem;
  isLoadingsubItems?: boolean = false;
  createdDate: string;
  cssClass: string;
}

